module.exports = __webpack_public_path__ + "b2fe465259e4d3bc0ae403d393804a03.MP3";